export default "__VITE_ASSET__21870234__"